import round from 'lodash/round'
import localeDecimals from './localeDecimals'

export default function roundMoney(number) {
  const locale = global.currentLocale || 'es_CL'
  const decimals = localeDecimals[locale] || 0

  return round(number, decimals)
}
